import { useEffect, useState } from "react";
import "./TimeInput.scss";
export const TimeInput: React.FC<{
  label: string;
  ms: number | undefined;
  onChange: (ms: number) => void;
}> = ({ label, onChange, ms }) => {
  const [value, setValue] = useState<{ sec: number; ms: number }>(
    ms !== undefined
      ? {
          sec: Math.floor(ms / 1000),
          ms: ms % 1000,
        }
      : { sec: 0, ms: 0 },
  );

  useEffect(() => {
    onChange(value.sec * 1000 + value.ms);
  }, [value]);

  return (
    <>
      <p className="time-input__wrapper__label">{label}</p>
      <div className="time-input__wrapper">
        <input
          className="time-input__wrapper__input"
          type="number"
          value={value.sec === 0 ? "" : value.sec}
          onChange={(sec) =>
            setValue({ sec: Number(sec.target.value), ms: value.ms })
          }
          maxLength={2}
        />
        .
        <input
          className="time-input__wrapper__input"
          type="number"
          value={value.ms.toString().padStart(3, "0")}
          onChange={(ms) =>
            setValue({
              ms: Math.min(999, Math.max(0, Number(ms.target.value))),
              sec: value.sec,
            })
          }
        />
        s
      </div>
    </>
  );
};
